import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../config";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${BACKEND_URL}/api.php?module=customers`
      );

      const data = await res.json();

      if (data.success) {
        setCustomers(data.data);
      } else {
        setError(data.message || "Failed to load customers");
      }

    } catch (err) {
      setError("Server error ❌");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this customer?")) return;

    try {
      const res = await fetch(
        `${BACKEND_URL}/api.php?module=customers&action=delete&id=${id}`,
        { method: "POST" }
      );

      const data = await res.json();

      if (data.success) {
        setCustomers(customers.filter((c) => c.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }

    } catch (err) {
      alert("Server error ❌");
    }
  };

  return (
    <div className="admin-page">

      <h2>Customers</h2>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <div className="admin-table">
          <table>

            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {customers.length > 0 ? (
                customers.map((c) => (
                  <tr key={c.id}>
                    <td>#{c.id}</td>
                    <td>{c.name}</td>
                    <td>{c.email}</td>

                    <td className="action-btns">
                      <button
                        className="admin-btn delete"
                        onClick={() => handleDelete(c.id)}
                      >
                        Delete
                      </button>
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No customers found</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      )}

    </div>
  );
}

export default Customers;